import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

export default function FormikSelect(props) {
  let { disabled, label, fieldValue, options, handleChange } = props;
  return (
    <FormControl
      fullWidth
      className="select-drop-down-label-styling required-field"
    >
      <InputLabel
        id="demo-simple-select-helper-label"
        className="input-field-dropdown-styling required-label"
      >
        {label}
      </InputLabel>
      <Select
        disabled={disabled}
        label={label}
        value={fieldValue.value}
        onChange={handleChange}
        labelId="demo-simple-select-helper-label"
        id="demo-simple-select-helper"
        className={"input-field-styling"}
        MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
      >
        {options?.length > 0 &&
          options?.map((item, ind) => (
            <MenuItem key={`${item}+${ind}`} id={`${item}+${ind}`} value={item}>
              {item}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
